export default "__VITE_ASSET__C4ZsW080__"